import { render } from 'preact';
import './styles/main.css';
import { App } from './app';

// Service worker registration is injected automatically by vite-plugin-pwa
// (see registerSW.js in the build output).
render(<App />, document.getElementById('app')!);
